export function getHeaderColor(pathname) {
  if (pathname === "/" || pathname.includes("/projects/")) return true;
  else false;
}

export function getMonth(month) {
  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "Novemeber",
    "Decemeber",
  ];

  return months.at(month - 1);
}

export function getMonthYear(date) {
  const month = getMonth(new Date(date).getMonth()).slice(0, 3);
  const year = new Date(date).getFullYear();

  return { month, year };
}

export function emailValidity(email) {
  return String(email)
    .toLowerCase()
    .match(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    )
    ? true
    : false;
}

export function phoneValidity(phone) {
  const phoneNumber = phone.replace(/[^\d]/g, "");
  return phoneNumber.length > 6 && phoneNumber.length < 16 ? true : false;
}
